import { render, staticRenderFns } from "./Modal-item.vue?vue&type=template&id=33d2a8c8&scoped=true&lang=pug"
import script from "./Modal-item.vue?vue&type=script&lang=js"
export * from "./Modal-item.vue?vue&type=script&lang=js"
import style0 from "./Modal-item.vue?vue&type=style&index=0&id=33d2a8c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d2a8c8",
  null
  
)

export default component.exports